const mr = {
  'English': 'इंग्रजी',
  'Hindi': 'हिंदी',
  'Marathi': 'मराठी',
  'Dashboard': 'डॅशबोर्ड',
  'Network': 'नेटवर्क',
  'Leads': 'लीड्स',
  'Learning Center': 'लर्निंग सेंटर',
  'Platform Tour': 'प्लॅटफॉर्म टूर',
  'About Us': 'आमच्याबद्दल',
  'Offline': 'ऑफलाइन',
  'Notifications': 'सूचना',
  'Notifications ({count} unread)': 'सूचना ({count} न वाचलेल्या)',
  'Loading notifications...': 'सूचना लोड होत आहेत...',
  'No new notifications': 'नवीन सूचना नाहीत',
  'Mark all as read': 'सर्व वाचल्याचे चिन्हांकित करा',
  'Hi, {name}': 'नमस्कार, {name}',
  'My Profile': 'माझे प्रोफाइल',
  'Scan Attendance QR': 'उपस्थिती QR स्कॅन करा',
  'Android App': 'अँड्रॉइड अॅप',
  'Settings': 'सेटिंग्स',
  'Platform Invoices': 'प्लॅटफॉर्म इनव्हॉइसेस',
  'Convert To Customer': 'ग्राहकात रूपांतर करा',
  'Force Refresh App': 'अॅप रिफ्रेश करा',
  'Logout': 'लॉगआउट',
  'This will clear all cached data and refresh the app. Continue?': 'यामुळे सर्व कॅश डेटा साफ होईल आणि अॅप पुन्हा रिफ्रेश होईल. पुढे जाऊ का?',
  'Preparing Android app download...': 'अँड्रॉइड अॅप डाउनलोडची तयारी सुरू आहे...',
  'Downloading Android app... {percent}%': 'अँड्रॉइड अॅप डाउनलोड होत आहे... {percent}%',
  'Downloading Android app...': 'अँड्रॉइड अॅप डाउनलोड होत आहे...',
  'Android app download started.': 'अँड्रॉइड अॅप डाउनलोड सुरू झाले आहे.',
  'Android app download timed out. Please try again.': 'अँड्रॉइड अॅप डाउनलोडची वेळ संपली. कृपया पुन्हा प्रयत्न करा.',
  'Failed to download Android app. Please try again.': 'अँड्रॉइड अॅप डाउनलोड करता आले नाही. कृपया पुन्हा प्रयत्न करा.',
  'Install CalorieNSweat App': 'CalorieNSweat अॅप इन्स्टॉल करा',
  'Add to your home screen for quick access': 'जलद वापरासाठी होम स्क्रीनवर जोडा',
  'Later': 'नंतर',
  'Install': 'इन्स्टॉल',
  'Built with affection': 'आपुलकीने तयार केलेले',
  'by': 'द्वारे',
  'Welcome, {name}!': 'स्वागत आहे, {name}!',
  'Reset Password': 'पासवर्ड रीसेट करा',
  'Email Address': 'ईमेल पत्ता',
  'Email Address or Username': 'ईमेल पत्ता किंवा युजरनेम',
  'Enter email or username': 'ईमेल किंवा युजरनेम टाका',
  'Enter your email address': 'तुमचा ईमेल पत्ता टाका',
  'Password': 'पासवर्ड',
  'Hide password': 'पासवर्ड लपवा',
  'Show password': 'पासवर्ड दाखवा',
  'Please complete the reCAPTCHA verification': 'कृपया reCAPTCHA पडताळणी पूर्ण करा',
  'reCAPTCHA not available on localhost. This is normal for development.': 'localhost वर reCAPTCHA उपलब्ध नाही. विकासासाठी हे सामान्य आहे.',
  'reCAPTCHA verification failed. Please refresh the page and try again.': 'reCAPTCHA पडताळणी अयशस्वी झाली. कृपया पृष्ठ रिफ्रेश करा आणि पुन्हा प्रयत्न करा.',
  'Login': 'लॉगिन',
  'Logging in...': 'लॉगिन सुरू आहे...',
  'Forgot Password?': 'पासवर्ड विसरलात?',
  'Forgot your password?': 'तुमचा पासवर्ड विसरलात का?',
  'Contact your administrator for account access': 'खात्याच्या प्रवेशासाठी तुमच्या प्रशासकाशी संपर्क करा',
  'By using CalorienSweat, you agree to our:': 'CalorienSweat वापरून तुम्ही आमच्या पुढील बाबींना सहमती देता:',
  'Privacy Policy': 'गोपनीयता धोरण',
  'Terms of Service': 'सेवेच्या अटी',
  'Signing in...': 'साइन इन सुरू आहे...',
  'Sign In': 'साइन इन',
  'Sending...': 'पाठवले जात आहे...',
  'Send Reset Link': 'रीसेट लिंक पाठवा',
  'Back to Login': 'लॉगिनकडे परत',
  'Invalid or missing reset token.': 'रीसेट टोकन अवैध आहे किंवा उपलब्ध नाही.',
  'Invalid or expired reset token.': 'रीसेट टोकन अवैध आहे किंवा कालबाह्य झाले आहे.',
  'Passwords do not match.': 'पासवर्ड जुळत नाहीत.',
  'Password must be at least 6 characters long.': 'पासवर्ड किमान 6 अक्षरांचा असणे आवश्यक आहे.',
  'Failed to reset password. Please try again.': 'पासवर्ड रीसेट करता आला नाही. कृपया पुन्हा प्रयत्न करा.',
  'Invalid Reset Link': 'अवैध रीसेट लिंक',
  'Request New Reset Link': 'नवीन रीसेट लिंक मागवा',
  'Password Reset Successful!': 'पासवर्ड रीसेट यशस्वी!',
  'Your password has been successfully reset. You will be redirected to the login page in a few seconds.': 'तुमचा पासवर्ड यशस्वीरीत्या रीसेट झाला आहे. काही सेकंदांत तुम्हाला लॉगिन पेजवर नेले जाईल.',
  'Go to Login': 'लॉगिनकडे जा',
  'Verifying reset link...': 'रीसेट लिंक पडताळली जात आहे...',
  'Set New Password': 'नवीन पासवर्ड सेट करा',
  'New Password': 'नवीन पासवर्ड',
  'Enter new password (min 6 characters)': 'नवीन पासवर्ड टाका (किमान 6 अक्षरे)',
  'Confirm New Password': 'नवीन पासवर्डची पुष्टी करा',
  'Confirm new password': 'नवीन पासवर्डची पुष्टी करा',
  'Resetting...': 'रीसेट होत आहे...',
  'If your email is registered with us, you will receive a password reset link.': 'तुमचा ईमेल आमच्याकडे नोंदणीकृत असल्यास, तुम्हाला पासवर्ड रीसेट लिंक मिळेल.',
  'Reports': 'अहवाल',
  'Please select both start and end dates': 'कृपया सुरुवात आणि समाप्तीच्या दोन्ही तारखा निवडा',
  'Date range cannot exceed more than one year': 'तारीख श्रेणी एक वर्षापेक्षा जास्त असू शकत नाही',
  'Start date cannot be after end date': 'सुरुवातीची तारीख समाप्तीच्या तारखेनंतर असू शकत नाही',
  'Failed to generate report. Please try again.': 'अहवाल तयार करता आला नाही. कृपया पुन्हा प्रयत्न करा.',
  'Failed to generate attendance report. Please try again.': 'उपस्थिती अहवाल तयार करता आला नाही. कृपया पुन्हा प्रयत्न करा.',
  'Failed to generate profit report. Please try again.': 'नफा अहवाल तयार करता आला नाही. कृपया पुन्हा प्रयत्न करा.',
  'Failed to export attendance report. Please try again.': 'उपस्थिती अहवाल एक्सपोर्ट करता आला नाही. कृपया पुन्हा प्रयत्न करा.',
  'No data to export': 'एक्सपोर्ट करण्यासाठी डेटा नाही',
  'Reports Dashboard': 'अहवाल डॅशबोर्ड',
  'Generate detailed reports for your business analysis': 'तुमच्या व्यवसाय विश्लेषणासाठी सविस्तर अहवाल तयार करा',
  'Available Reports': 'उपलब्ध अहवाल',
  'Invoice Reports': 'इनव्हॉइस अहवाल',
  'Generate detailed invoice reports with payment information, GST breakdown, and volume points': 'पेमेंट माहिती, GST तपशील आणि व्हॉल्यूम पॉइंट्ससह सविस्तर इनव्हॉइस अहवाल तयार करा',
  'Attendance Reports': 'उपस्थिती अहवाल',
  'Generate monthly attendance reports for your club customers': 'तुमच्या क्लब ग्राहकांसाठी मासिक उपस्थिती अहवाल तयार करा',
  'Profit Reports': 'नफा अहवाल',
  'Analyze profit margins and volume points distribution across products and programs': 'प्रोडक्ट्स आणि प्रोग्राम्समधील नफा मार्जिन आणि व्हॉल्यूम पॉइंट्स वितरणाचे विश्लेषण करा',
  'More Reports Coming Soon': 'आणखी अहवाल लवकरच येत आहेत',
  'Additional report types will be added in future updates': 'भविष्यातील अपडेटमध्ये आणखी अहवाल प्रकार जोडले जातील',
  'Invoice Report Generator': 'इनव्हॉइस अहवाल जनरेटर',
  'Program Invoice': 'प्रोग्राम इनव्हॉइस',
  'Product Invoice': 'प्रॉडक्ट इनव्हॉइस',
  'GST will not be charged or shown because your company GSTIN is not configured.': 'तुमच्या कंपनीचा GSTIN कॉन्फिगर केलेला नाही, त्यामुळे GST आकारला किंवा दाखवला जाणार नाही.',
  'Maximum shipping charges allowed: ₹300. GST will not be charged.': 'कमाल शिपिंग शुल्क ₹300 आहे. GST आकारला जाणार नाही.',
  'Generating...': 'तयार होत आहे...',
  'Generate Report': 'अहवाल तयार करा',
  'Export CSV': 'CSV एक्सपोर्ट करा',
  'Note: Date range cannot exceed more than one year': 'टीप: तारीख श्रेणी एक वर्षापेक्षा जास्त असू शकत नाही',
  'Invoice Report Results ({count} entries)': 'इनव्हॉइस अहवाल निकाल ({count} नोंदी)',
  'Period': 'कालावधी',
  'Invoice ID': 'इनव्हॉइस ID',
  'Invoice Date': 'इनव्हॉइस तारीख',
  'Customer Name': 'ग्राहकाचे नाव',
  'Mode of Payment': 'पेमेंट पद्धत',
  'CGST Amount': 'CGST रक्कम',
  'SGST Amount': 'SGST रक्कम',
  'Total of Invoice': 'इनव्हॉइसची एकूण रक्कम',
  'GST Codes': 'GST कोड्स',
  'Report Summary': 'अहवाल सारांश',
  'Total Entries': 'एकूण नोंदी',
  'Total Payments': 'एकूण पेमेंट्स',
  'Total CGST': 'एकूण CGST',
  'Total SGST': 'एकूण SGST',
  'Attendance Report Generator': 'उपस्थिती अहवाल जनरेटर',
  'Month': 'महिना',
  'Year': 'वर्ष',
  'Attendance Summary ({count} customers)': 'उपस्थिती सारांश ({count} ग्राहक)',
  'Present Days': 'उपस्थित दिवस',
  'Absent Days': 'अनुपस्थित दिवस',
  'Attendance %': 'उपस्थिती %',
  'Total Customers': 'एकूण ग्राहक',
  'Total Present': 'एकूण उपस्थित',
  'Total Absent': 'एकूण अनुपस्थित',
  'Days in Month': 'महिन्यातील दिवस',
  'Profit & Volume Points Report': 'नफा आणि व्हॉल्यूम पॉइंट्स अहवाल',
  'Profit Analysis Report': 'नफा विश्लेषण अहवाल',
  'Total Profit': 'एकूण नफा',
  'Total Volume Points': 'एकूण व्हॉल्यूम पॉइंट्स',
  'Total Cost to Company': 'एकूण कॉस्ट टू कंपनी',
  'Revenue in Pipeline': 'पाइपलाइनमधील रेव्हेन्यू',
  'Sales in Pipeline': 'पाइपलाइनमधील विक्री',
  'Product Cost': 'प्रोडक्ट खर्च',
  'Program Cost': 'प्रोग्राम खर्च',
  'Program Renewal Profit': 'प्रोग्राम नूतनीकरण संभाव्य नफा',
  'Program Renewal Sales': 'प्रोग्राम नूतनीकरण विक्री',
  'Payment Due': 'पेमेंट बाकी',
  'Membership Discounts': 'मेंबरशिप सवलती',
  'Custom Discounts': 'कस्टम सवलती',
  'Profit Distribution': 'नफा वितरण',
  'No profit data available for this period': 'या कालावधीसाठी नफा डेटा उपलब्ध नाही',
  'Product Sales': 'प्रोडक्ट विक्री',
  'Program Sales': 'प्रोग्राम विक्री',
  'Service Sales': 'सर्विस विक्री',
  'Services': 'सर्विसेस',
  'Volume Points Distribution': 'व्हॉल्यूम पॉइंट्स वितरण',
  'No volume points data available for this period': 'या कालावधीसाठी व्हॉल्यूम पॉइंट्स डेटा उपलब्ध नाही',
  'Discount Distribution': 'सवलत वितरण',
  'No discount data available for this period': 'या कालावधीसाठी सवलत डेटा उपलब्ध नाही',
  'Detailed Breakdown': 'सविस्तर तपशील',
  'Profit Margins': 'नफा मार्जिन',
  'Discount Breakdown': 'सवलत तपशील',
  'Cost to Company Breakdown': 'कॉस्ट टू कंपनी तपशील',
  'Pipeline Breakdown': 'पाइपलाइन तपशील',
  'Program Renewal Revenue': 'प्रोग्राम नूतनीकरण रेव्हेन्यू',
  'Pending Dues': 'प्रलंबित देय',
  'Total Pipeline Revenue': 'एकूण पाइपलाइन रेव्हेन्यू',
  'Membership': 'मेंबरशिप',
  'Custom': 'कस्टम',
  'My Customers': 'माझे ग्राहक',
  'Affiliated Customers': 'संलग्न ग्राहक',
  'From affiliated clubs': 'संलग्न क्लबमधून',
  'First Line Supervisors': 'पहिल्या स्तराचे सुपरवायझर',
  'All Line Supervisors': 'सर्व स्तरांचे सुपरवायझर',
  'Org Tree View': 'संघटनात्मक ट्री दृश्य',
  "Today's Checkup": 'आजची तपासणी',
  "Today's Birthday": 'आजचे वाढदिवस',
  "Today's Followups": 'आजचे फॉलो-अप',
  "Today's Lead Followups": 'आजचे लीड फॉलो-अप',
  'Upcoming Followups': 'आगामी फॉलो-अप',
  'Upcoming Followups (Next 7 Days)': 'आगामी फॉलो-अप (पुढील 7 दिवस)',
  'Customer Followup': 'ग्राहक फॉलो-अप',
  'Lead Followup': 'लीड फॉलो-अप',
  'Customer Acquisition': 'ग्राहक प्राप्ती',
  'Customer Acquisition Report': 'ग्राहक प्राप्ती अहवाल',
  'Analyze customer growth from actively subscribed coaches across your hierarchy': 'संपूर्ण श्रेणीतील सक्रिय सदस्यता असलेल्या कोचच्या ग्राहक वाढीचे विश्लेषण करा',
  'Track new customers by month and coach ownership.': 'महिना आणि कोचनुसार नवीन ग्राहकांचा मागोवा घ्या.',
  'Report Scope': 'अहवालाची व्याप्ती',
  'Self': 'स्वतः',
  'Org': 'संस्था',
  'My customers (active subscription)': 'माझे ग्राहक (सक्रिय सदस्यता)',
  "Customers of active descendant coaches": 'सक्रिय अधीनस्थ कोचचे ग्राहक',
  'From Month': 'सुरुवातीचा महिना',
  'To Month': 'शेवटचा महिना',
  'Start month cannot be after end month': 'सुरुवातीचा महिना शेवटच्या महिन्यानंतर असू शकत नाही',
  'Failed to generate customer acquisition report. Please try again.': 'ग्राहक प्राप्ती अहवाल तयार करता आला नाही. कृपया पुन्हा प्रयत्न करा.',
  'New Customers': 'नवीन ग्राहक',
  'Monthly Average': 'मासिक सरासरी',
  'Leading Coach': 'आघाडीचा कोच',
  'Selected Period': 'निवडलेला कालावधी',
  'Monthly Acquisition Trend': 'मासिक ग्राहक वाढ',
  'New customers created in each selected month': 'प्रत्येक निवडलेल्या महिन्यात तयार झालेले नवीन ग्राहक',
  'Monthly customer acquisition bar chart': 'मासिक ग्राहक प्राप्ती बार चार्ट',
  'Acquisition by Coach': 'कोचनुसार ग्राहक प्राप्ती',
  'Contribution across the complete coach hierarchy': 'संपूर्ण कोच श्रेणीचे योगदान',
  'No descendant coaches found.': 'कोणतेही अधीनस्थ कोच सापडले नाहीत.',
  'New Customer Details': 'नवीन ग्राहक तपशील',
  '{count} customers in the selected period': 'निवडलेल्या कालावधीत {count} ग्राहक',
  'No new customers found for the selected period and scope.': 'निवडलेल्या कालावधी आणि व्याप्तीत नवीन ग्राहक सापडले नाहीत.',
  'Contact': 'संपर्क',
  'Coach': 'कोच',
  'Online': 'ऑनलाइन',
  'Online Clients': 'ऑनलाइन ग्राहक',
  'Club Clients': 'क्लब ग्राहक',
  'Type Not Set': 'प्रकार निश्चित नाही',
  'Not Set': 'निश्चित नाही',
  'Customer type legend': 'ग्राहक प्रकार संकेत',
  'Renewal Due': 'नूतनीकरण बाकी',
  'Renewal Due (Next 7 Days)': 'नूतनीकरण बाकी (पुढील 7 दिवस)',
  'Due Payments': 'देय पेमेंट्स',
  'QR Attendance Marker': 'QR उपस्थिती मार्कर',
  'Generate QR for attendance': 'उपस्थितीसाठी QR तयार करा',
  'Attendance Marker': 'उपस्थिती मार्कर',
  'Failed to generate QR code. Please ensure your company information is set up.': 'QR कोड तयार करता आला नाही. कृपया तुमची कंपनी माहिती सेटअप केली आहे याची खात्री करा.',
  'Failed to load customers. Please try again.': 'ग्राहक लोड करता आले नाहीत. कृपया पुन्हा प्रयत्न करा.',
  'Failed to download instructions PDF. Please try again.': 'सूचना PDF डाउनलोड करता आले नाही. कृपया पुन्हा प्रयत्न करा.',
  'Failed to mark attendance for today. Please try again.': 'आजची उपस्थिती नोंदवता आली नाही. कृपया पुन्हा प्रयत्न करा.',
  'Please select a customer and at least one date': 'कृपया एक ग्राहक आणि किमान एक तारीख निवडा',
  'Attendance marked successfully for selected dates!': 'निवडलेल्या तारखांसाठी उपस्थिती यशस्वीरित्या नोंदवली!',
  'Attendance de-marked successfully for selected dates!': 'निवडलेल्या तारखांसाठी उपस्थिती यशस्वीरित्या काढली!',
  'Failed to mark attendance. Please try again.': 'उपस्थिती नोंदवता आली नाही. कृपया पुन्हा प्रयत्न करा.',
  'Failed to de-mark attendance. Please try again.': 'उपस्थिती काढता आली नाही. कृपया पुन्हा प्रयत्न करा.',
  'Generating attendance QR code...': 'उपस्थिती QR कोड तयार होत आहे...',
  'Attendance QR Code': 'उपस्थिती QR कोड',
  'QR Code Details': 'QR कोड तपशील',
  "Today's Date": 'आजची तारीख',
  'Permanent QR. No daily printing required.': 'स्थायी QR. दररोज प्रिंटची गरज नाही.',
  'Download Instructions PDF': 'सूचना PDF डाउनलोड करा',
  'Mark Attendance': 'उपस्थिती नोंदवा',
  'De-Mark Attendance': 'उपस्थिती काढा',
  'Permanent QR Code - Valid Every Day': 'स्थायी QR कोड - दररोज वैध',
  'Customers Present Today ({count})': 'आज उपस्थित ग्राहक ({count})',
  'Search present...': 'उपस्थित शोधा...',
  'No matching attendance found.': 'जुळणारी उपस्थिती सापडली नाही.',
  'No attendance recorded yet for today.': 'आजसाठी अजून उपस्थिती नोंदलेली नाही.',
  'Present': 'उपस्थित',
  'Yet To Mark Today ({count})': 'आज अजून नोंदवायचे ({count})',
  'Search pending...': 'प्रलंबित शोधा...',
  'No matching customers found.': 'जुळणारे ग्राहक सापडले नाहीत.',
  'All active club customers have marked attendance today.': 'सर्व सक्रिय क्लब ग्राहकांनी आज उपस्थिती नोंदवली आहे.',
  'Marking...': 'नोंदवले जात आहे...',
  'Mark Today': 'आज नोंदवा',
  'Manually Mark Attendance': 'हस्ते उपस्थिती नोंदवा',
  'Manually De-Mark Attendance': 'हस्ते उपस्थिती काढा',
  'Search Customer': 'ग्राहक शोधा',
  'Search by name, email, or phone...': 'नाव, ईमेल किंवा फोनने शोधा...',
  'Selected Customer': 'निवडलेला ग्राहक',
  'Select Date(s)': 'तारीख निवडा',
  'Selected Dates ({count})': 'निवडलेल्या तारखा ({count})',
  'De-marking...': 'काढले जात आहे...',
  'Product Management': 'उत्पादन व्यवस्थापन',
  'Document Management': 'दस्तऐवज व्यवस्थापन',
  'Access Management': 'अॅक्सेस व्यवस्थापन',
  'Pending Promotion Requests': 'प्रलंबित पदोन्नती विनंत्या',
  'Lead Management': 'लीड व्यवस्थापन',
  'Meal Plan Templates': 'मील प्लॅन टेम्पलेट्स',
  'Training Videos Management': 'प्रशिक्षण व्हिडिओ व्यवस्थापन',
  'Leaderboard': 'लीडरबोर्ड',
  'Challenge Management': 'चॅलेंज व्यवस्थापन',
  'Challenges': 'चॅलेंजेस',
  'My Dashboard': 'माझा डॅशबोर्ड',
  'Manage Associates': 'सहकाऱ्यांचे व्यवस्थापन',
  'Platform Invoices Management': 'प्लॅटफॉर्म इनव्हॉइस व्यवस्थापन',
  'Subscription Invoices Management': 'सदस्यता इनव्हॉइस व्यवस्थापन',
  'Language': 'भाषा',
  'Toggle mobile menu': 'मोबाइल मेनू उघडा/बंद करा',
  'Close': 'बंद करा',
  'Cancel': 'रद्द करा',
  'Save': 'जतन करा',
  'Save Changes': 'बदल जतन करा',
  'Saving...': 'जतन होत आहे...',
  'Add': 'जोडा',
  'Add More': 'आणखी जोडा',
  'Edit': 'संपादित करा',
  'Delete': 'हटवा',
  'Deleting...': 'हटवत आहे...',
  'Remove': 'काढा',
  'Refresh': 'रिफ्रेश करा',
  'Retry': 'पुन्हा प्रयत्न करा',
  'Submit': 'सबमिट करा',
  'Search': 'शोधा',
  'Search...': 'शोधा...',
  'Type to search...': 'शोधण्यासाठी टाइप करा...',
  'Clear selection': 'निवड साफ करा',
  'Actions': 'कृती',
  'Action': 'कृती',
  'Status': 'स्थिती',
  'Active': 'सक्रिय',
  'Inactive': 'निष्क्रिय',
  'Archived': 'संग्रहीत',
  'Pending': 'प्रलंबित',
  'Approved': 'मंजूर',
  'Rejected': 'नाकारले',
  'Customer': 'ग्राहक',
  'Customers': 'ग्राहक',
  'Member': 'सदस्य',
  'Members': 'सदस्य',
  'Participant': 'सहभागी',
  'Participants': 'सहभागी',
  'Name': 'नाव',
  'First Name': 'पहिले नाव',
  'Last Name': 'आडनाव',
  'Username': 'युजरनेम',
  'Gender': 'लिंग',
  'Phone': 'फोन',
  'Address': 'पत्ता',
  'Age': 'वय',
  'Date of Birth': 'जन्मतारीख',
  'Weight': 'वजन',
  'Height': 'उंची',
  'Email': 'ईमेल',
  'Type': 'प्रकार',
  'Description': 'वर्णन',
  'Category': 'श्रेणी',
  'Amount': 'रक्कम',
  'Notes': 'नोंदी',
  'Date': 'दिनांक',
  'Created': 'तयार केले',
  'Uploaded': 'अपलोड केले',
  'Joined': 'जॉइन झाले',
  'Start Date': 'सुरुवातीची तारीख',
  'End Date': 'समाप्तीची तारीख',
  'Program': 'प्रोग्राम',
  'Programs': 'प्रोग्राम्स',
  'Health Readings': 'हेल्थ रीडिंग्स',
  'Invoices': 'इनव्हॉइसेस',
  'Health Reports': 'हेल्थ रिपोर्ट्स',
  'Meal Plan': 'मील प्लॅन',
  'Referrals': 'रेफरल्स',
  'Loading customer details...': 'ग्राहक तपशील लोड होत आहेत...',
  'Back to Customers': 'ग्राहकांकडे परत',
  'Customer Details': 'ग्राहक तपशील',
  'Customer Information': 'ग्राहक माहिती',
  'Promote To Coach': 'कोचकडे पदोन्नती द्या',
  'Club Change': 'क्लब बदला',
  'Edit Customer': 'ग्राहक संपादित करा',
  'Personal Details': 'वैयक्तिक तपशील',
  'Account Details': 'खाते तपशील',
  'Program Details': 'प्रोग्राम तपशील',
  'GST Number': 'GST क्रमांक',
  'Discomforts & Medications': 'अस्वस्थता आणि औषधे',
  'PC ID/Associate ID': 'PC ID/असोसिएट ID',
  'Referred By': 'संदर्भ दिलेला',
  'Active Program': 'सक्रिय प्रोग्राम',
  'No Active Program': 'सक्रिय प्रोग्राम नाही',
  'Checkup Day': 'चेकअप दिवस',
  'Program Discount': 'प्रोग्राम सवलत',
  'Product Discount': 'उत्पादन सवलत',
  'Basic': 'बेसिक',
  'Basic (MRP)': 'बेसिक (MRP)',
  'N/A': 'लागू नाही',
  'Failed to load your details. Please try again.': 'तुमचे तपशील लोड करता आले नाहीत. कृपया पुन्हा प्रयत्न करा.',
  'Meal plan link is missing': 'मील प्लॅनची लिंक उपलब्ध नाही',
  'Failed to open meal plan. Please try again.': 'मील प्लॅन उघडता आला नाही. कृपया पुन्हा प्रयत्न करा.',
  'Failed to download document. Please try again.': 'दस्तऐवज डाउनलोड करता आला नाही. कृपया पुन्हा प्रयत्न करा.',
  'Failed to download invoice. Please try again.': 'इनव्हॉइस डाउनलोड करता आला नाही. कृपया पुन्हा प्रयत्न करा.',
  'Failed to download health report. Please try again.': 'हेल्थ रिपोर्ट डाउनलोड करता आला नाही. कृपया पुन्हा प्रयत्न करा.',
  'Reading date and weight are required.': 'रीडिंग तारीख आणि वजन आवश्यक आहे.',
  'Failed to add health reading. Please try again.': 'हेल्थ रीडिंग जोडता आली नाही. कृपया पुन्हा प्रयत्न करा.',
  'Loading your dashboard...': 'तुमचा डॅशबोर्ड लोड होत आहे...',
  'My Information': 'माझी माहिती',
  'Email': 'ईमेल',
  'Phone': 'फोन',
  'Gender': 'लिंग',
  'Address': 'पत्ता',
  'Customer Type': 'ग्राहक प्रकार',
  'ONLINE': 'ऑनलाइन',
  'CLUB': 'क्लब',
  'MALE': 'पुरुष',
  'FEMALE': 'महिला',
  'ACTIVE': 'सक्रिय',
  'INACTIVE': 'निष्क्रिय',
  'BLOCKED': 'ब्लॉक केलेले',
  'PAID': 'भरलेले',
  'PENDING': 'प्रलंबित',
  'OVERDUE': 'मुदत उलटलेले',
  'CANCELLED': 'रद्द केलेले',
  'My Health Readings': 'माझ्या हेल्थ रीडिंग्स',
  'Add Reading': 'रीडिंग जोडा',
  'No health readings found. Click "Add Reading" to record your first health reading.': 'कोणतीही हेल्थ रीडिंग्स सापडली नाहीत. तुमची पहिली हेल्थ रीडिंग नोंदवण्यासाठी "रीडिंग जोडा" क्लिक करा.',
  'No health readings found. Your coach will add readings after your checkups.': 'कोणतीही हेल्थ रीडिंग्स सापडली नाहीत. तुमचे कोच तपासणीनंतर रीडिंग्स जोडतील.',
  'Weight (kg)': 'वजन (कि.ग्रॅ.)',
  'Visceral Fat': 'व्हिसरल फॅट',
  'Total Fat (%)': 'एकूण फॅट (%)',
  'Meta Age': 'मेटा एज',
  'Skeletal Muscle (%)': 'स्केलेटल मसल (%)',
  'TSF': 'TSF',
  'TSF (mm)': 'TSF (मिमी)',
  'Date': 'तारीख',
  'Description': 'वर्णन',
  'Amount': 'रक्कम',
  'Due Date': 'देय तारीख',
  'Actions': 'क्रिया',
  '{count} payment(s) • Balance: ₹{amount}': '{count} पेमेंट(s) • शिल्लक: ₹{amount}',
  'Paid: ₹{amount}': 'भरले: ₹{amount}',
  'Download PDF': 'PDF डाउनलोड करा',
  'Download': 'डाउनलोड करा',
  'My Invoices': 'माझे इनव्हॉइसेस',
  'No invoices found.': 'कोणतेही इनव्हॉइसेस सापडले नाहीत.',
  'Referals': 'रेफरल्स',
  'My Referals': 'माझे रेफरल्स',
  'Loading referals...': 'रेफरल्स लोड होत आहेत...',
  'No referals found.': 'कोणतेही रेफरल्स सापडले नाहीत.',
  'Name': 'नाव',
  'My Health Library': 'माझे हेल्थ लायब्ररी',
  'Access documents and resources for {customerType} members': '{customerType} सदस्यांसाठी दस्तऐवज आणि साधने वापरा',
  'Loading documents...': 'दस्तऐवज लोड होत आहेत...',
  'No documents available for {customerType} members at the moment.': 'सध्या {customerType} सदस्यांसाठी कोणतेही दस्तऐवज उपलब्ध नाहीत.',
  'Health Videos ({count})': 'हेल्थ व्हिडिओज ({count})',
  'Added by {name} • {date}': '{name} यांनी जोडले • {date}',
  'Watch Video': 'व्हिडिओ पाहा',
  'Watch': 'पाहा',
  'Documents ({count})': 'दस्तऐवज ({count})',
  'Document': 'दस्तऐवज',
  'Category': 'श्रेणी',
  'Action': 'क्रिया',
  'No description': 'वर्णन नाही',
  'Download Document': 'दस्तऐवज डाउनलोड करा',
  'No documents or videos available for {customerType} members at the moment.': 'सध्या {customerType} सदस्यांसाठी कोणतेही दस्तऐवज किंवा व्हिडिओ उपलब्ध नाहीत.',
  'No health reports found. Your coach will generate reports based on your health readings.': 'कोणतेही हेल्थ रिपोर्ट्स सापडले नाहीत. तुमचे कोच तुमच्या हेल्थ रीडिंग्सवर आधारित रिपोर्ट तयार करतील.',
  'No programs assigned yet. Your coach will assign programs based on your goals.': 'अजून कोणतेही प्रोग्राम नियुक्त केलेले नाहीत. तुमचे कोच तुमच्या उद्दिष्टांनुसार प्रोग्राम नियुक्त करतील.',
  'My Cashback Wallet': 'माझे कॅशबॅक वॉलेट',
  'Total Earned: ₹{earned} | Total Used: ₹{used}': 'एकूण कमाई: ₹{earned} | एकूण वापरले: ₹{used}',
  'Loading cashback data...': 'कॅशबॅक डेटा लोड होत आहे...',
  'Cashback Earned ({count})': 'मिळालेले कॅशबॅक ({count})',
  'No cashback earned yet. Refer friends to earn cashback!': 'अजून कॅशबॅक मिळालेले नाही. मित्रांना रेफर करा आणि कॅशबॅक मिळवा!',
  'Referral': 'रेफरल',
  'Cashback Used ({count})': 'वापरलेले कॅशबॅक ({count})',
  'No cashback used yet.': 'अजून कॅशबॅक वापरलेले नाही.',
  'Used for Invoice': 'इनव्हॉइससाठी वापरले',
  'No meal plans assigned yet. Your coach will assign meal plans based on your goals and preferences.': 'अजून कोणतेही मील प्लॅन्स नियुक्त केलेले नाहीत. तुमचे कोच तुमच्या उद्दिष्टे आणि पसंतीनुसार मील प्लॅन्स देतील.',
  'Open': 'उघडा',
  'Reading Date': 'रीडिंग तारीख',
  'BMR (kcal)': 'BMR (kcal)',
  'Metabolic Age': 'मेटाबॉलिक एज',
  'Male Leaders': 'पुरुष लीडर्स',
  'Female Leaders': 'महिला लीडर्स',
  'Online Male Leaders': 'ऑनलाइन पुरुष लीडर्स',
  'Club Male Leaders': 'क्लब पुरुष लीडर्स',
  'Online Female Leaders': 'ऑनलाइन महिला लीडर्स',
  'Club Female Leaders': 'क्लब महिला लीडर्स',
  'Full leaderboard list ranked by {metric} for this category.': 'या श्रेणीसाठी {metric} नुसार क्रमवारी लावलेली पूर्ण लीडरबोर्ड यादी.',
  'weight loss': 'वजन घट',
  'percentage of weight loss': 'वजन घट टक्केवारी',
  'Best Weight Loss': 'सर्वोत्तम वजन घट',
  'Best % Loss': 'सर्वोत्तम % घट',
  'Loading members...': 'सदस्य लोड होत आहेत...',
  'No members found for this category.': 'या श्रेणीसाठी कोणतेही सदस्य सापडले नाहीत.',
  'Latest three weight entries are shown as week1, week2, and week3.': 'शेवटच्या तीन वजन नोंदी week1, week2 आणि week3 म्हणून दाखवल्या आहेत.',
  'Total': 'एकूण',
  'Rank': 'क्रमांक',
  'Participant': 'सहभागी',
  'Start Weight': 'सुरुवातीचे वजन',
  'End Weight': 'शेवटचे वजन',
  'Weight Loss': 'वजन घट',
  '% Loss': '% घट',
  'Week1': 'आठवडा1',
  'Week2': 'आठवडा2',
  'Week3': 'आठवडा3',
  'Top 3 Transformation Leaders': 'टॉप 3 ट्रान्सफॉर्मेशन लीडर्स',
  'Premium podium view for the strongest weight-loss results in this challenge category.': 'या चॅलेंज श्रेणीतील सर्वोत्तम वजन घट परिणामांसाठी प्रीमियम पोडियम दृश्य.',
  'Rank #{rank}': 'क्रमांक #{rank}',
  'Drill down': 'तपशील पाहा',
  'Loading leaders...': 'लीडर्स लोड होत आहेत...',
  'No qualifying customers found for this range.': 'या कालावधीसाठी पात्र ग्राहक सापडले नाहीत.',
  'Loss': 'घट',
  'ALL': 'सर्व',
  'Failed to load leaderboard.': 'लीडरबोर्ड लोड करता आला नाही.',
  'Failed to load members.': 'सदस्य लोड करता आले नाहीत.',
  'Leaderboard Details': 'लीडरबोर्ड तपशील',
  'Track top customer weight loss in the challenge leaderboard.': 'चॅलेंज लीडरबोर्डमध्ये टॉप ग्राहकांच्या वजन घटेचा मागोवा घ्या.',
  'Track top customer weight loss across club, org, and challenge views.': 'क्लब, ऑर्ग आणि चॅलेंज दृश्यांमध्ये टॉप ग्राहकांच्या वजन घटेचा मागोवा घ्या.',
  'Club Level': 'क्लब स्तर',
  'Org Level': 'ऑर्ग स्तर',
  'Challenge Level': 'चॅलेंज स्तर',
  'Challenge Date Range': 'चॅलेंज तारीख श्रेणी',
  'Select a challenge': 'चॅलेंज निवडा',
  'Loading challenges...': 'चॅलेंजेस लोड होत आहेत...',
  'No challenges available.': 'कोणतेही चॅलेंजेस उपलब्ध नाहीत.',
  'Club Level Leaders': 'क्लब स्तर लीडर्स',
  'Org Level Leaders': 'ऑर्ग स्तर लीडर्स',
  'Back to Dashboard': 'डॅशबोर्डकडे परत',
  'Reshare Invoice on WhatsApp': 'WhatsApp वर इनव्हॉइस पुन्हा शेअर करा',
  'Invoice reshared successfully over WhatsApp.': 'इनव्हॉइस WhatsApp वर यशस्वीपणे पुन्हा शेअर केले गेले.',
  'Failed to reshare invoice over WhatsApp. Please try again.': 'इनव्हॉइस WhatsApp वर पुन्हा शेअर करता आले नाही. कृपया पुन्हा प्रयत्न करा.',
  'years': 'वर्षे',
  'Customer Meal Plans': 'ग्राहक मील प्लॅन्स',
  'Add Meal Plan': 'मील प्लॅन जोडा',
  'Loading meal plans...': 'मील प्लॅन्स लोड होत आहेत...',
  'No meal plans found. Click "Add Meal Plan" to create the first meal plan.': 'कोणतेही मील प्लॅन्स सापडले नाहीत. पहिला मील प्लॅन तयार करण्यासाठी "मील प्लॅन जोडा" क्लिक करा.',
  'Customer Referrals': 'ग्राहक रेफरल्स',
  'Loading referrals...': 'रेफरल्स लोड होत आहेत...',
  'No referrals found for this customer.': 'या ग्राहकासाठी कोणतेही रेफरल्स सापडले नाहीत.',
  'Health Readings History': 'हेल्थ रीडिंग्स इतिहास',
  'Log Monitoring': 'दैनिक नोंद निरीक्षण',
  'Generate Health Report': 'हेल्थ रिपोर्ट तयार करा',
  'Loading health readings...': 'हेल्थ रीडिंग्स लोड होत आहेत...',
  'No health readings found. Click "Add Health Reading" to add the first reading.': 'कोणतीही हेल्थ रीडिंग्स सापडली नाहीत. पहिली रीडिंग जोडण्यासाठी "हेल्थ रीडिंग जोडा" क्लिक करा.',
  'Customer Invoices': 'ग्राहक इनव्हॉइसेस',
  'Add Invoice': 'इनव्हॉइस जोडा',
  'Loading invoices...': 'इनव्हॉइसेस लोड होत आहेत...',
  'No invoices found. Click "Add Invoice" to create the first invoice.': 'कोणतेही इनव्हॉइसेस सापडले नाहीत. पहिला इनव्हॉइस तयार करण्यासाठी "इनव्हॉइस जोडा" क्लिक करा.',
  'Loading health reports...': 'हेल्थ रिपोर्ट्स लोड होत आहेत...',
  'No health reports found. Generate your first AI-powered health report from the Health Readings tab.': 'कोणतेही हेल्थ रिपोर्ट्स सापडले नाहीत. हेल्थ रीडिंग्स टॅबमधून तुमचा पहिला AI-आधारित हेल्थ रिपोर्ट तयार करा.',
  'Assigned Programs': 'नियुक्त प्रोग्राम्स',
  'Assign Program': 'प्रोग्राम नियुक्त करा',
  'Loading programs...': 'प्रोग्राम्स लोड होत आहेत...',
  'No programs assigned yet. Click "Assign Program" to assign the first program.': 'अजून कोणतेही प्रोग्राम नियुक्त केलेले नाहीत. पहिला प्रोग्राम नियुक्त करण्यासाठी "प्रोग्राम नियुक्त करा" क्लिक करा.',
  'Create Meal Plan for {name}': '{name} साठी मील प्लॅन तयार करा',
  'Select Criteria': 'निकष निवडा',
  'User data not available. Please try again.': 'युजर डेटा उपलब्ध नाही. कृपया पुन्हा प्रयत्न करा.',
  'Failed to load complete profile data. Some fields may be empty.': 'पूर्ण प्रोफाइल डेटा लोड करता आला नाही. काही फील्ड्स रिकामी असू शकतात.',
  'This email address is already registered': 'हा ईमेल पत्ता आधीच नोंदणीकृत आहे',
  'This username is already registered': 'हे युजरनेम आधीच नोंदणीकृत आहे',
  'Please fix the email validation error before submitting.': 'सबमिट करण्यापूर्वी ईमेल व्हॅलिडेशन त्रुटी दुरुस्त करा.',
  'Please fix the username validation error before submitting.': 'सबमिट करण्यापूर्वी युजरनेम व्हॅलिडेशन त्रुटी दुरुस्त करा.',
  'Failed to update profile. Please try again.': 'प्रोफाइल अपडेट करता आले नाही. कृपया पुन्हा प्रयत्न करा.',
  'Profile Updated Successfully!': 'प्रोफाइल यशस्वीरित्या अपडेट झाले!',
  'Your profile information has been updated.': 'तुमची प्रोफाइल माहिती अपडेट झाली आहे.',
  'Loading profile data...': 'प्रोफाइल डेटा लोड होत आहे...',
  'New Password (leave blank to keep current)': 'नवीन पासवर्ड (सध्याचा ठेवायचा असल्यास रिकामे ठेवा)',
  'Updating...': 'अपडेट होत आहे...',
  'Update Profile': 'प्रोफाइल अपडेट करा',
  "Failed to load today's attendance status. Please try again.": "आजची उपस्थिती स्थिती लोड करता आली नाही. कृपया पुन्हा प्रयत्न करा.",
  'Please select an image file (PNG, JPG, GIF)': 'कृपया प्रतिमेची फाइल निवडा (PNG, JPG, GIF)',
  'Logo file size must be less than 5MB': 'लोगो फाइल आकार 5MB पेक्षा कमी असावा',
  'Logo will be automatically resized to fit within 240x240 pixels': 'लोगो आपोआप 240x240 पिक्सेलमध्ये बसवण्यासाठी आकार बदलला जाईल',
  'Invalid FSSAI number': 'अवैध FSSAI नंबर',
  'Failed to save company information. Please try again.': 'कंपनी माहिती सेव्ह करता आली नाही. कृपया पुन्हा प्रयत्न करा.',
  'Are you sure you want to delete the company logo?': 'तुम्हाला कंपनी लोगो हटवायचा आहे याची खात्री आहे का?',
  'Logo deleted successfully': 'लोगो यशस्वीरित्या हटवला',
  'Failed to delete logo. Please try again.': 'लोगो हटवता आला नाही. कृपया पुन्हा प्रयत्न करा.',
  'Failed to save club affiliation. Please try again.': 'क्लब संलग्नता सेव्ह करता आली नाही. कृपया पुन्हा प्रयत्न करा.',
  'Company Information Saved Successfully!': 'कंपनी माहिती यशस्वीरित्या सेव्ह झाली!',
  'Club Affiliation Updated Successfully!': 'क्लब संलग्नता यशस्वीरित्या अपडेट झाली!',
  'Your company information has been updated.': 'तुमची कंपनी माहिती अपडेट झाली आहे.',
  'Your club affiliation has been updated.': 'तुमची क्लब संलग्नता अपडेट झाली आहे.',
  "Today's Attendance": 'आजची उपस्थिती',
  "Loading today's attendance...": 'आजची उपस्थिती लोड होत आहे...',
  'Marked At': 'नोंदवलेले वेळ',
  'Company Setup Required': 'कंपनी सेटअप आवश्यक',
  'Please complete your company information to continue using the platform. This information is required for invoice generation and compliance.': 'प्लॅटफॉर्म वापरणे सुरू ठेवण्यासाठी कृपया तुमची कंपनी माहिती पूर्ण करा. ही माहिती इनव्हॉइस जनरेशन आणि अनुपालनासाठी आवश्यक आहे.',
  'Complete Setup & Continue': 'सेटअप पूर्ण करा आणि पुढे चला',
  'Save Company Information': 'कंपनी माहिती सेव्ह करा',
  'My Company': 'माझी कंपनी',
  'Club Affiliation': 'क्लब संलग्नता',
  'Club Affiliation Settings': 'क्लब संलग्नता सेटिंग्स',
  'Club Ownership Type': 'क्लब मालकी प्रकार',
  'Intern Club Owner': 'इंटर्न क्लब ओनर',
  'Select Club Owner': 'क्लब ओनर निवडा',
  'Select a club owner': 'क्लब ओनर निवडा',
  'Select the club owner you are affiliated with': 'ज्या क्लब ओनरशी तुम्ही संलग्न आहात तो निवडा',
  'Current Club Affiliation': 'सध्याची क्लब संलग्नता',
  'Affiliated with': 'संलग्न',
  'You are operating as an independent club owner': 'तुम्ही स्वतंत्र क्लब ओनर म्हणून काम करत आहात',
  'About Club Affiliation': 'क्लब संलग्नतेबद्दल',
  'You operate independently and manage your own club': 'तुम्ही स्वतंत्रपणे काम करता आणि तुमचा स्वतःचा क्लब सांभाळता',
  'You are affiliated with another club owner and operate under their guidance': 'तुम्ही दुसऱ्या क्लब ओनरशी संलग्न आहात आणि त्यांच्या मार्गदर्शनाखाली काम करता',
  'Save Affiliation': 'संलग्नता सेव्ह करा',
  'Failed to add payment. Please try again.': 'पेमेंट जोडता आले नाही. कृपया पुन्हा प्रयत्न करा.',
  'You have items in your invoice. Please generate the invoice first or remove all items before switching invoice type.': 'तुमच्या इनव्हॉइसमध्ये आयटम्स आहेत. इनव्हॉइस तयार करा किंवा प्रकार बदलण्यापूर्वी सर्व आयटम्स काढून टाका.',
  'Note: You cannot mix products and programs in a single invoice': 'टीप: एका इनव्हॉइसमध्ये प्रोडक्ट्स आणि प्रोग्राम्स एकत्र करता येत नाहीत',
  'Override with Custom Discount': 'कस्टम सवलतीने ओव्हरराईड करा',
  'Custom Discount Amount': 'कस्टम सवलत रक्कम',
  "This will override customer's program discount slab. Items will be shown at MRP.": 'यामुळे ग्राहकाचा प्रोग्राम डिस्काउंट स्लॅब ओव्हरराईड होईल. आयटम्स MRP वर दाखवले जातील.',
  'Include Shipping Charges': 'शिपिंग चार्जेस समाविष्ट करा',
  'Shipping Charges': 'शिपिंग चार्जेस',
  'Shipping charges cannot exceed ₹300': 'शिपिंग चार्जेस ₹300 पेक्षा जास्त असू शकत नाहीत',
  'Enter shipping charges (max ₹300)': 'शिपिंग चार्जेस टाका (कमाल ₹300)',
  'Maximum shipping charges allowed: ₹300. GST will be calculated at 18% (9% CGST + 9% SGST).': 'कमाल शिपिंग चार्जेस ₹300. GST 18% (9% CGST + 9% SGST) ने मोजला जाईल.',
  'off': 'सूट',
  'Basic (0% off)': 'बेसिक (0% सूट)',
  'Basic (MRP pricing)': 'बेसिक (MRP किंमत)',
  'Select {item}': '{item} निवडा',
  'Search {items}...': '{items} शोधा...',
  'No {items} available': '{items} उपलब्ध नाहीत',
  'No {items} found': '{items} सापडले नाहीत',
  'products': 'प्रोडक्ट्स',
  'programs': 'प्रोग्राम्स',
  'Basic (MRP)': 'बेसिक (MRP)',
  'Fixed Price (No Discount)': 'फिक्स्ड किंमत (सवलत नाही)',
  'Basic (0%)': 'बेसिक (0%)',
  'Add Item': 'आयटम जोडा',
  'Cashback Wallet': 'कॅशबॅक वॉलेट',
  'Available Balance': 'उपलब्ध शिल्लक',
  'Modify Cashback': 'कॅशबॅक बदला',
  'This amount will be deducted from your cashback balance and applied as discount to the invoice.': 'ही रक्कम तुमच्या कॅशबॅक शिल्लक मधून वजा होऊन इनव्हॉइसवर सवलत म्हणून लागू होईल.',
  'Subtotal (Before {type})': 'सबटोटल ({type} आधी)',
  'Subtotal (After {type})': 'सबटोटल ({type} नंतर)',
  'Custom Discount': 'कस्टम सवलत',
  'Cashback': 'कॅशबॅक',
  'CGST ({rate}%)': 'CGST ({rate}%)',
  'SGST ({rate}%)': 'SGST ({rate}%)',
  'Program/Product Discount': 'प्रोग्राम/प्रोडक्ट सवलत',
  "Great! You're saving ₹{amount} with cashback discount. GST has been recalculated on the reduced amount.": 'छान! तुम्ही कॅशबॅक सवलतीने ₹{amount} वाचवत आहात. GST कमी रकमेवर पुन्हा मोजला गेला आहे.',
  'e.g., Monthly program fee': 'उदा., मासिक प्रोग्राम फी',
  'Full Payment': 'पूर्ण पेमेंट',
  'Partial Payment': 'आंशिक पेमेंट',
  'No Payment': 'पेमेंट नाही',
  'Select Mode': 'मोड निवडा',
  'Overdue': 'थकित',
  'Cancelled': 'रद्द',
  'Additional notes...': 'अतिरिक्त नोंदी...',
  'Invoice Details': 'इनव्हॉइस तपशील',
  'Already Paid': 'आधीच भरले',
  'Remaining': 'शिल्लक',
  'Max: ₹{amount}': 'कमाल: ₹{amount}',
  'Payment reference, transaction ID, etc.': 'पेमेंट संदर्भ, ट्रान्झॅक्शन आयडी इत्यादी.',
  'Failed to load coaches. Please try again.': 'कोच लोड करता आले नाहीत. कृपया पुन्हा प्रयत्न करा.',
  'Please select a coach': 'कृपया कोच निवडा',
  'Coach requested club change for customer': 'कोचने ग्राहकासाठी क्लब बदल विनंती केली',
  'Failed to submit request. Please try again.': 'विनंती सबमिट करता आली नाही. कृपया पुन्हा प्रयत्न करा.',
  'Club Change Request Submitted!': 'क्लब बदल विनंती सबमिट झाली!',
  'Your request has been sent to the Upline Tab Team for approval.': 'तुमची विनंती मंजुरीसाठी अपलाइन टॅब टीमकडे पाठवली आहे.',
  'Request Club Change': 'क्लब बदल विनंती करा',
  'Club Change Request for {name}': '{name} साठी क्लब बदल विनंती',
  'This request will be sent to the Upline Tab Team for approval. Once approved:': 'ही विनंती मंजुरीसाठी अपलाइन टॅब टीमकडे पाठवली जाईल. मंजूर झाल्यावर:',
  "Customer's coach will be changed to the selected coach": 'ग्राहकाचा कोच निवडलेल्या कोचकडे बदलला जाईल',
  "Customer will be moved under the new coach's hierarchy": 'ग्राहक नवीन कोचच्या हायरार्कीखाली हलवला जाईल',
  "Customer's access and programs will remain the same": 'ग्राहकाचा प्रवेश आणि प्रोग्राम तसेच राहतील',
  'Current Coach': 'सध्याचा कोच',
  'Your current coach': 'तुमचा सध्याचा कोच',
  'Select New Coach': 'नवीन कोच निवडा',
  'Loading coaches...': 'कोच लोड होत आहेत...',
  'Select a coach': 'कोच निवडा',
  'Reason for Change (Optional)': 'बदलाचे कारण (पर्यायी)',
  'This request requires approval from the Upline Tab Team. You will be notified once your request is reviewed.': 'या विनंतीसाठी अपलाइन टॅब टीमची मंजुरी आवश्यक आहे. तुमची विनंती तपासल्यानंतर तुम्हाला कळवले जाईल.',
  'Submitting...': 'सबमिट होत आहे...',
  'Submit Request': 'विनंती सबमिट करा',
  'Conversion Request Submitted!': 'रूपांतरण विनंती सबमिट झाली!',
  'Transition From Coach to Customer': 'कोचपासून ग्राहकाकडे रूपांतरण',
  'Your role will be changed from Coach to Customer': 'तुमची भूमिका कोचवरून ग्राहक अशी बदलेल',
  'You will lose access to coach features and tools': 'तुमचा कोच फीचर्स आणि टूल्सवरील प्रवेश जाईल',
  'Your immediate customers will be moved to your parent coach': 'तुमचे थेट ग्राहक तुमच्या पॅरेंट कोचकडे हलवले जातील',
  'You will become a customer under your parent coach': 'तुम्ही तुमच्या पॅरेंट कोचखाली ग्राहक व्हाल',
  'This action can be reversed with another promotion request': 'ही कृती दुसऱ्या पदोन्नती विनंतीने उलटवता येईल',
  'This request requires approval from the Upline Tab Team. You will be notified once your request is reviewed. This action will significantly change your account permissions.': 'या विनंतीसाठी अपलाइन टॅब टीमची मंजुरी आवश्यक आहे. तुमची विनंती तपासल्यानंतर तुम्हाला कळवले जाईल. या कृतीमुळे तुमच्या खात्याच्या परवानग्यांमध्ये मोठा बदल होईल.',
  'Please enter a valid cashback amount': 'कृपया वैध कॅशबॅक रक्कम टाका',
  'Amount cannot exceed your cashback balance of ₹{amount}': 'रक्कम तुमच्या ₹{amount} कॅशबॅक शिल्लकपेक्षा जास्त असू शकत नाही',
  'Amount cannot exceed current subtotal of ₹{amount}': 'रक्कम सध्याच्या ₹{amount} सबटोटलपेक्षा जास्त असू शकत नाही',
  'Apply Cashback Discount': 'कॅशबॅक सवलत लागू करा',
  'Available Cashback Balance': 'उपलब्ध कॅशबॅक शिल्लक',
  'Current Invoice Subtotal': 'सध्याचा इनव्हॉइस सबटोटल',
  'Maximum cashback you can apply': 'तुम्ही लागू करू शकणारा कमाल कॅशबॅक',
  'Cashback Amount to Apply': 'लागू करावयाची कॅशबॅक रक्कम',
  'Enter amount between ₹0.01 and ₹{amount}': '₹0.01 आणि ₹{amount} दरम्यान रक्कम टाका',
  'How it works': 'हे कसे काम करते',
  'Cashback is applied as a discount to the invoice subtotal': 'कॅशबॅक इनव्हॉइस सबटोटलवर सवलत म्हणून लागू होतो',
  'This cashback will be deducted from your available balance': 'हा कॅशबॅक तुमच्या उपलब्ध शिल्लकातून वजा केला जाईल',
  'You can modify or remove the cashback before generating the invoice': 'इनव्हॉइस तयार करण्यापूर्वी तुम्ही कॅशबॅक बदलू किंवा काढू शकता',
  'Clear Cashback': 'कॅशबॅक साफ करा',
  'Apply Cashback': 'कॅशबॅक लागू करा',
  'Promote Customer to Coach': 'ग्राहकाला कोच करा',
  'Important': 'महत्त्वाचे',
  'Promoting this customer to coach will': 'या ग्राहकाला कोच केल्यास',
  'Change their role from Customer to Coach': 'त्यांची भूमिका ग्राहकावरून कोच होईल',
  'Grant them access to coach features': 'त्यांना कोच फीचर्सचा प्रवेश मिळेल',
  'Allow them to manage their own customers': 'त्यांना स्वतःचे ग्राहक व्यवस्थापित करता येतील',
  'This action cannot be easily undone': 'ही कृती सहजपणे उलटवता येणार नाही',
  'Are you sure you want to send a promotion request for {name} to become a coach?': '{name} यांना कोच बनवण्यासाठी पदोन्नती विनंती पाठवायची याची खात्री आहे का?',
  'What happens next': 'पुढे काय होईल',
  'Upline Tab Team will receive an email notification': 'अपलाइन टॅब टीमला ईमेल सूचना मिळेल',
  'They will also see a notification in their dashboard': 'त्यांना त्यांच्या डॅशबोर्डमध्ये सूचना दिसेल',
  'An approver will review and either approve or reject the request': 'एक मंजूरकर्ता विनंती तपासून मंजूर किंवा नाकारेल',
  'You will be notified of the decision': 'तुम्हाला निर्णयाची माहिती दिली जाईल',
  'If approved, all customers referred by {name} will become your direct customers': 'मंजूर झाल्यास, {name} यांनी रेफर केलेले सर्व ग्राहक तुमचे थेट ग्राहक होतील',
  'Promoting...': 'पदोन्नती होत आहे...',
  'Promote to Coach': 'कोच करा',
  'Assign Program to {name}': '{name} ला प्रोग्राम नियुक्त करा',
  'Select Program': 'प्रोग्राम निवडा',
  'Showing {type} programs only': 'फक्त {type} प्रोग्राम दाखवले जात आहेत',
  'Comments': 'कॉमेंट्स',
  'Additional comments about program assignment...': 'प्रोग्राम नियुक्तीबद्दल अतिरिक्त कॉमेंट्स...',
  'Assigning...': 'नियुक्त होत आहे...',
  'Assign Now': 'आता नियुक्त करा',
  'Balance Volume Points': 'शिल्लक व्हॉल्यूम पॉइंट्स',
  'Reason for Stopping Program': 'प्रोग्राम थांबवण्याचे कारण',
  'No attendance records found for this program period.': 'या प्रोग्राम कालावधीसाठी उपस्थिती नोंदी सापडल्या नाहीत.',
  'Attendance Dates ({count} days)': 'उपस्थिती दिनांक ({count} दिवस)',
  "This will send the meal plan link to the customer's WhatsApp number.": 'यामुळे मील प्लॅनची लिंक ग्राहकाच्या व्हॉट्सअॅप नंबरवर पाठवली जाईल.',
  'Program Information': 'प्रोग्राम माहिती',
  'Program Name': 'प्रोग्राम नाव',
  'Program Code': 'प्रोग्राम कोड',
  'Assigned Date': 'नियुक्ती दिनांक',
  'Balance Points': 'शिल्लक पॉइंट्स',
  'Assignment Comments': 'नियुक्ती कॉमेंट्स',
  'Program Stop Reason': 'प्रोग्राम थांबवण्याचे कारण',
  'Stopped on': 'थांबवले दिनांक',
  'Program Statistics': 'प्रोग्राम आकडेवारी',
  'Total Duration': 'एकूण कालावधी',
  'Attendance Rate': 'उपस्थिती दर',
  'Points Utilization': 'पॉइंट्स वापर',
  'Days Remaining': 'उर्वरित दिवस',
  'Program Completed': 'प्रोग्राम पूर्ण',
  'Program Expired': 'प्रोग्राम कालबाह्य',
  '{count} days': '{count} दिवस',
  'Company Information': 'कंपनी माहिती',
  'GSTIN': 'GSTIN',
  'FSSAI': 'FSSAI',
  'Invoice Date': 'इनव्हॉइस दिनांक',
  'Bill To': 'बिल करा',
  'Discount Plan': 'सवलत योजना',
  'Invoice Type': 'इनव्हॉइस प्रकार',
  'Program Invoice (18% GST)': 'प्रोग्राम इनव्हॉइस (18% GST)',
  'Product Invoice (5% GST)': 'प्रोडक्ट इनव्हॉइस (5% GST)',
  'Add Line Items': 'लाइन आयटम्स जोडा',
  'Quantity': 'प्रमाण',
  'Discount Applied': 'लागू सवलत',
  'Invoice Items': 'इनव्हॉइस आयटम्स',
  'Item': 'आयटम',
  'Qty': 'प्रमाण',
  'MRP': 'MRP',
  'Discounted Price': 'सवलतीची किंमत',
  'Cashback Applied': 'कॅशबॅक लागू',
  'Invoice Calculations': 'इनव्हॉइस गणना',
  'Custom Discount Applied': 'कस्टम सवलत लागू',
  'Shipping (Base)': 'शिपिंग (मूळ)',
  'Shipping CGST (9%)': 'शिपिंग CGST (9%)',
  'Shipping SGST (9%)': 'शिपिंग SGST (9%)',
  'Total Shipping': 'एकूण शिपिंग',
  'Total Savings': 'एकूण बचत',
  'Final Amount': 'अंतिम रक्कम',
  'Current Role': 'सध्याची भूमिका',
  'Code': 'कोड',
  'Duration': 'कालावधी',
  'to': 'ते',
  'Loading attendance data...': 'उपस्थिती डेटा लोड होत आहे...',
  'Meal Plan Name': 'मील प्लॅन नाव',
  'Weight Category': 'वजन श्रेणी',
  'Food Preference': 'अन्न पसंती',
  'Created Date': 'तयार दिनांक',
  'Share via WhatsApp': 'व्हॉट्सअॅपवर शेअर करा',
  'Delete Meal Plan': 'मील प्लॅन हटवा',
  'Weight (kg)': 'वजन (कि.ग्रॅ.)',
  'Visceral Fat': 'व्हिसेरल फॅट',
  'TSF': 'TSF',
  'Total Fat (%)': 'एकूण चरबी (%)',
  'Meta Age': 'मेटा वय',
  'BMI': 'BMI',
  'BMR': 'BMR',
  'Skeletal Muscle (%)': 'स्केलेटल मसल (%)',
  'Ideal Values': 'आदर्श मूल्ये',
  'Edit Reading': 'रीडिंग संपादित करा',
  'Delete Reading': 'रीडिंग हटवा',
  'Invoice #': 'इनव्हॉइस #',
  'Total Amount': 'एकूण रक्कम',
  'Payment Info': 'पेमेंट माहिती',
  'Due Date': 'देय तारीख',
  '{count} payment(s) made': '{count} पेमेंट झाले',
  'Paid': 'भरले',
  'Total Paid': 'एकूण भरले',
  'Balance': 'शिल्लक',
  'Last': 'शेवटचे',
  'Mode': 'मोड',
  'Add Partial Payment': 'आंशिक पेमेंट जोडा',
  'Edit Invoice': 'इनव्हॉइस संपादित करा',
  'Delete Invoice': 'इनव्हॉइस हटवा',
  'Cancel Invoice': 'इनव्हॉइस रद्द करा',
  'Are you sure you want to cancel this invoice?': 'तुम्हाला ही इनव्हॉइस रद्द करायची आहे का?',
  'Failed to cancel invoice. Please try again.': 'इनव्हॉइस रद्द करता आली नाही. कृपया पुन्हा प्रयत्न करा.',
  'Report Date': 'रिपोर्ट दिनांक',
  'Generated By': 'यांनी तयार केले',
  'File Size': 'फाइल आकार',
  'Delete Report': 'रिपोर्ट हटवा',
  'Volume Points': 'व्हॉल्यूम पॉइंट्स',
  'Days Attended': 'हजर दिवस',
  'Assigned By': 'यांनी नियुक्त केले',
  'Consumption / Total': 'वापर / एकूण',
  'Days Present': 'उपस्थित दिवस',
  'View Program Details': 'प्रोग्राम तपशील पहा',
  'View Attendance': 'उपस्थिती पहा',
  'Stop Program': 'प्रोग्राम थांबवा',
  'Stop': 'थांबवा',
  'Delete Program': 'प्रोग्राम हटवा',
  'Available Templates': 'उपलब्ध टेम्पलेट्स',
  'Meal Plan Details': 'मील प्लॅन तपशील',
  'Creating...': 'तयार होत आहे...',
  'Create Meal Plan': 'मील प्लॅन तयार करा',
  'Share Meal Plan via WhatsApp': 'व्हॉट्सअॅपद्वारे मील प्लॅन शेअर करा',
  'Club': 'क्लब',
  'Company': 'कंपनी',
  'City': 'शहर',
  'State': 'राज्य',
  'Pincode': 'पिनकोड',
  'Payment Date': 'भरणा दिनांक',
  'Payment Mode': 'भरणा पद्धत',
  'Payment Reference / Notes': 'भरणा संदर्भ / नोंदी',
  'Amount Paid': 'भरलेली रक्कम',
  'Add Payment': 'पेमेंट जोडा',
  'Adding...': 'जोडले जात आहे...',
  'Cash': 'रोख',
  'Card': 'कार्ड',
  'Bank Transfer': 'बँक ट्रान्सफर',
  'Cheque': 'चेक',
  'Net Banking': 'नेट बँकिंग',
  'Profile': 'प्रोफाइल',
  'Company Settings': 'कंपनी सेटिंग्स',
  'Attendance': 'उपस्थिती',
  'Attendance Marked': 'उपस्थिती नोंदवली',
  'Yet To Mark Attendance': 'अजून उपस्थिती नोंदवायची आहे',
  'Loading settings...': 'सेटिंग्स लोड होत आहेत...',
  'Loading...': 'लोड होत आहे...',
  'Please wait...': 'कृपया थांबा...',
  'View': 'पहा',
  'Download': 'डाउनलोड करा',
  'Download PDF': 'पीडीएफ डाउनलोड करा',
  'Download Document': 'दस्तऐवज डाउनलोड करा',
  'Watch Video': 'व्हिडिओ पहा',
  'Open Meal Plan': 'मील प्लॅन उघडा',
  'Company Name': 'कंपनीचे नाव',
  'Phone Number': 'फोन नंबर',
  'Address Line 1': 'पत्ता ओळ 1',
  'Address Line 2': 'पत्ता ओळ 2',
  'GSTIN Number': 'GSTIN क्रमांक',
  'FSSAI Number': 'FSSAI क्रमांक',
  'Company Level': 'कंपनी स्तर',
  'Herbalife Level': 'हर्बालाइफ स्तर',
  'Company Logo': 'कंपनी लोगो',
  'Current Logo': 'सध्याचा लोगो',
  'Logo Preview': 'लोगो पूर्वावलोकन',
  'Delete Logo': 'लोगो हटवा',
  'Complete Setup & Continue': 'सेटअप पूर्ण करा आणि पुढे जा',
  'Save Company Information': 'कंपनीची माहिती जतन करा',
  'Club Affiliation': 'क्लब संलग्नता',
  'Select Affiliation': 'संलग्नता निवडा',
  'Loading today\'s attendance...': 'आजची उपस्थिती लोड होत आहे...',
  'Marked At:': 'नोंद वेळ:',
  'My Health Library': 'माझी हेल्थ लायब्ररी',
  'My Health Reports': 'माझे हेल्थ रिपोर्ट्स',
  'My Programs': 'माझे प्रोग्राम्स',
  'My Cashback Wallet': 'माझे कॅशबॅक वॉलेट',
  'My Meal Plans': 'माझे मील प्लॅन्स',
  'Add Health Reading': 'हेल्थ रीडिंग जोडा',
  'Document': 'दस्तऐवज',
  'Report Date': 'रिपोर्ट दिनांक',
  'Generated By': 'निर्माता',
  'File Size': 'फाइल आकार',
  'Meal Plan Name': 'मील प्लॅन नाव',
  'Weight Category': 'वजन श्रेणी',
  'Food Preference': 'अन्न पसंती',
  'Created Date': 'तयार दिनांक',
  'Assigned By': 'नियुक्त केलेले',
  'Volume Points': 'व्हॉल्युम पॉइंट्स',
  'Days Attended': 'उपस्थित दिवस',
  'Product': 'उत्पादन',
  'Products': 'उत्पादने',
  'Search leads...': 'लीड्स शोधा...',
  'Search products...': 'उत्पादने शोधा...',
  'Search affiliated customers...': 'संलग्न ग्राहक शोधा...',
  'Search by name, email, type or gender': 'नाव, ईमेल, प्रकार किंवा लिंगानुसार शोधा',
  'Enter username': 'युजरनेम टाका',
  'Enter phone number': 'फोन नंबर टाका',
  'No data found.': 'डेटा सापडला नाही.',
  'No records found.': 'रेकॉर्ड सापडले नाहीत.',
  'Back to Challenges': 'चॅलेंजेसकडे परत',
  'Challenge not found.': 'चॅलेंज सापडले नाही.',
  'Add Users to Challenge': 'चॅलेंजमध्ये वापरकर्ते जोडा',
  'Search and select referrer...': 'रेफरर शोधा आणि निवडा...',
  'Additional notes about the lead...': 'लीडबद्दल अतिरिक्त नोंदी...',
  'e.g., Mumbai, Maharashtra': 'उदा., मुंबई, महाराष्ट्र',
  'e.g., 75.5': 'उदा., 75.5',
  'e.g., 175.5': 'उदा., 175.5',
  'Auto-filled from DOB': 'जन्मतारखेवरून आपोआप भरलेले',
  'e.g., STK001': 'उदा., STK001',
  'e.g., Protein Powder': 'उदा., प्रोटीन पावडर',
  'e.g., 25.50': 'उदा., 25.50',
  'e.g., 2500.00': 'उदा., 2500.00',
  'e.g., 2250.00': 'उदा., 2250.00',
  'e.g., 2000.00': 'उदा., 2000.00',
  'Inventory Management': 'इन्व्हेंटरी व्यवस्थापन',
  'Upload E-invoices and track stock': 'E-invoice अपलोड करा आणि स्टॉक ट्रॅक करा',
  'Track inward stock from E-invoices or manual entries, then mark barcodes outward as stock leaves.': 'E-invoice किंवा मॅन्युअल एंट्रीमधून inward stock ट्रॅक करा, आणि stock बाहेर गेल्यावर barcode outward म्हणून चिन्हांकित करा.',
  'Current stock': 'सध्याचा स्टॉक',
  '{count} product types': '{count} उत्पादन प्रकार',
  'Upload E-invoice PDF': 'E-invoice PDF अपलोड करा',
  'PDF file': 'PDF फाइल',
  'Uploading...': 'अपलोड होत आहे...',
  'Upload and import': 'अपलोड आणि इम्पोर्ट करा',
  'Manual inward entry': 'मॅन्युअल inward एंट्री',
  'SKU': 'SKU',
  'Product name': 'उत्पादनाचे नाव',
  'Barcodes': 'बारकोड',
  'One per line or comma separated. Leave blank to create manual stock units.': 'प्रत्येक ओळीत एक किंवा कॉमाने वेगळे करा. मॅन्युअल स्टॉक युनिट तयार करण्यासाठी रिकामे ठेवा.',
  'Add inward stock': 'inward stock जोडा',
  'Inventory': 'इन्व्हेंटरी',
  'Search by product name or SKU': 'उत्पादन नाव किंवा SKU ने शोधा',
  'Loading inventory...': 'इन्व्हेंटरी लोड होत आहे...',
  'No stock found.': 'स्टॉक सापडला नाही.',
  'Details': 'तपशील',
  'Uploaded E-invoices': 'अपलोड केलेले E-invoices',
  'No E-invoices uploaded yet.': 'अजून कोणतेही E-invoice अपलोड केलेले नाही.',
  'File': 'फाइल',
  'Imported': 'इम्पोर्ट केले',
  'Page': 'पेज',
  'First matched page': 'पहिले जुळलेले पेज',
  'Uploaded at': 'अपलोड वेळ',
  '{items} items, {barcodes} barcodes': '{items} आयटम, {barcodes} बारकोड',
  'SKU {sku} | {count} in stock': 'SKU {sku} | स्टॉकमध्ये {count}',
  'Loading barcodes...': 'बारकोड लोड होत आहेत...',
  'No active barcodes remain for this item.': 'या आयटमसाठी सक्रिय बारकोड शिल्लक नाहीत.',
  'Barcode': 'बारकोड',
  'Source': 'स्रोत',
  'Inward at': 'Inward वेळ',
  'E-invoice': 'E-invoice',
  'Manual': 'मॅन्युअल',
  'Mark outward': 'Outward चिन्हांकित करा',
  'Confirm outward entry': 'Outward एंट्रीची पुष्टी करा',
  'This will reduce stock by 1 and keep the barcode record for compliance.': 'यामुळे स्टॉक 1 ने कमी होईल आणि compliance साठी बारकोड रेकॉर्ड जतन राहील.',
  'SKU {sku}': 'SKU {sku}',
  'Barcode {barcode}': 'बारकोड {barcode}',
  'Confirm outward': 'Outward पुष्टी करा',
  'In stock barcodes': 'स्टॉकमधील बारकोड',
  'Outward entries': 'आउटवर्ड एंट्रीज',
  'No outward entries recorded for this item.': 'या आयटमसाठी कोणतीही outward entry नोंदलेली नाही.',
  'E-invoice outward entries': 'E-invoice outward entries',
  'Loading outward entries...': 'Outward entries लोड होत आहेत...',
  'No outward entries recorded for this E-invoice.': 'या E-invoice साठी कोणतीही outward entry नोंदलेली नाही.',
  'Outward at': 'Outward वेळ',
  'Reason': 'कारण',
  'Outward reason': 'Outward कारण',
  'Add an optional comment for this outward entry.': 'या outward entry साठी वैकल्पिक टिप्पणी जोडा.',
  'Delete E-invoice': 'E-invoice हटवा',
  'This will delete all entries from inventory for the selected E-invoice. The file will also be removed from S3.': 'यामुळे निवडलेल्या E-invoice साठीच्या सर्व inventory entries हटवल्या जातील. फाइल देखील S3 मधून काढली जाईल.',
  'E-invoice deleted. Imported inventory entries were removed.': 'E-invoice हटवले. इम्पोर्ट केलेल्या inventory entries काढल्या.',
  'Unable to delete this E-invoice.': 'हे E-invoice हटवता आले नाही.',
  'Unable to load inventory right now.': 'सध्या इन्व्हेंटरी लोड करता आली नाही.',
  'Choose a PDF E-invoice before uploading.': 'अपलोड करण्यापूर्वी PDF E-invoice निवडा.',
  'E-invoice uploaded. {count} inward entries imported.': 'E-invoice अपलोड झाले. {count} inward entries इम्पोर्ट झाल्या.',
  'Unable to upload and parse this PDF.': 'ही PDF अपलोड आणि पार्स करता आली नाही.',
  'Manual inward entries added.': 'मॅन्युअल inward entries जोडल्या.',
  'Unable to save manual inward entries.': 'मॅन्युअल inward entries सेव्ह करता आल्या नाहीत.',
  'Unable to load barcode details.': 'बारकोड तपशील लोड करता आले नाहीत.',
  'Outward entry marked. Stock reduced by 1.': 'Outward entry चिन्हांकित झाली. स्टॉक 1 ने कमी झाला.',
  'Unable to mark this barcode outward.': 'हा बारकोड outward चिन्हांकित करता आला नाही.',
  'Unable to load E-invoice outward entries.': 'E-invoice outward entries लोड करता आल्या नाहीत.',
  'Paste QR code URL or UUID here': 'इथे QR कोड URL किंवा UUID पेस्ट करा',
  'Track inward and outward stock with customer-level history.': 'Track inward and outward stock with customer-level history.',
  'Current Inventory': 'Current Inventory',
  'Outward Stock': 'Outward Stock',
  'Outward Stock History': 'Outward Stock History',
  'Review stock issued to customers and counter consumption.': 'Review stock issued to customers and counter consumption.',
  'Unable to load outward history.': 'Unable to load outward history.',
  'Unable to search customers.': 'Unable to search customers.',
  'Unable to search inventory.': 'Unable to search inventory.',
  'Counter consumption': 'Counter consumption',
  'Maps to your logged-in account for club consumption.': 'Maps to your logged-in account for club consumption.',
  'Search direct or affiliated customers': 'Search direct or affiliated customers',
  'Select a customer or Counter consumption.': 'Select a customer or Counter consumption.',
  'Add at least one inventory item.': 'Add at least one inventory item.',
  'Outward stock recorded successfully.': 'Outward stock recorded successfully.',
  'Unable to record outward stock.': 'Unable to record outward stock.',
  'No outward transactions found for this date range.': 'No outward transactions found for this date range.',
  'Club use': 'Club use',
  'Create Outward Stock': 'Create Outward Stock',
  'Choose a recipient and add one or more inventory items.': 'Choose a recipient and add one or more inventory items.',
  'Recipient': 'Recipient',
  'Add inventory items': 'Add inventory items',
  'available': 'available',
  'Confirm Outward Stock': 'Confirm Outward Stock',
  'Outward Transaction Details': 'Outward Transaction Details',
  'This will delete imported inventory entries and the uploaded file.': 'This will delete imported inventory entries and the uploaded file.',
  'Edit Product Settlement': 'उत्पादन सेटलमेंट संपादित करा',
  'Correct the products, quantities, due date, or comments.': 'उत्पादने, प्रमाण, देय तारीख किंवा टिप्पण्या दुरुस्त करा.',
  'Update Settlement': 'सेटलमेंट अपडेट करा',
  'Unable to update product settlement.': 'उत्पादन सेटलमेंट अपडेट करता आले नाही.',
  'Unable to delete product settlement.': 'उत्पादन सेटलमेंट हटवता आले नाही.',
  'Deleting this settlement will also delete its return history. Continue?': 'हे सेटलमेंट हटवल्यास त्याचा परतावा इतिहासही हटेल. पुढे जायचे?',
  'Products with recorded returns cannot be removed.': 'नोंदवलेला परतावा असलेली उत्पादने हटवता येत नाहीत.',
  'Daily Log Monitoring': 'दैनिक लॉग निरीक्षण',
  'Submitted today': 'आज सबमिट केले',
  "Today's Daily Log Monitoring": 'आजचे दैनिक लॉग निरीक्षण',
  'Active Online and Club customers': 'सक्रिय ऑनलाइन आणि क्लब ग्राहक',
  'Active Customers': 'सक्रिय ग्राहक',
  'Submitted': 'सबमिट केले',
  'Not Submitted': 'सबमिट केले नाही',
  'Daily log submitted': 'दैनिक लॉग सबमिट केला',
  'Customers below 65% are highlighted for attention.': '65% पेक्षा कमी गुण असलेले ग्राहक लक्ष देण्यासाठी ठळक केले आहेत.',
  'No customers have submitted a daily log today.': 'आज कोणत्याही ग्राहकाने दैनिक लॉग सबमिट केलेला नाही.',
  'Daily log not submitted': 'दैनिक लॉग सबमिट केला नाही',
  'Every active customer has submitted a daily log today.': 'प्रत्येक सक्रिय ग्राहकाने आज दैनिक लॉग सबमिट केला आहे.',
  'View Daily Log': 'दैनिक लॉग पहा',
  'Not submitted': 'सबमिट केले नाही',
  'Loading daily log status...': 'दैनिक लॉग स्थिती लोड होत आहे...',
  'Unable to load daily log monitoring.': 'दैनिक लॉग निरीक्षण लोड करता आले नाही.',
  "Yesterday's log submitted": 'कालचा लॉग सबमिट केला',
  "Checking yesterday's log dated {date}": '{date} या तारखेच्या कालच्या लॉगची तपासणी',
  "No customers have submitted yesterday's daily log.": 'कोणत्याही ग्राहकाने कालचा दैनिक लॉग सबमिट केलेला नाही.',
  "Every active customer has submitted yesterday's daily log.": 'प्रत्येक सक्रिय ग्राहकाने कालचा दैनिक लॉग सबमिट केला आहे.',
};

export default mr;
